import { User } from "types";
import { useDataStore } from "@store/user_org";

const DEV_ORG_ID = "OJjnaOZpttbpnWS2Vb6u";

export function isGUEST(userData?: User | null): boolean {
  return userData?.config?.access_type === "GUEST";
}

export function isDevOrg(): boolean {
  return useDataStore.getState().orgData?.id === DEV_ORG_ID;
}

export function useIsDevOrg(): boolean {
  return useDataStore((s) => s.orgData?.id) === DEV_ORG_ID;
}
